export default __webpack_public_path__ + "static/media/txt2_pc.11aecb64.png";